export enum planFeatureID {
    sessions_per_month,
    max_participants_per_session,
    export_basic,
    export_apps,
    reporting_html,
    reporting_powerpoint,
    ai_ideas_grouping,
    ai_custom_participants,
}

export enum planFeatureAvailability {
    included,
    optional,
    excluded,
}